<template>
  <v-app>   
    <v-main>
      <v-container 
            class="fill-height justify-center" 
            fluid
        >
           <v-row 
            class="text-center"
            style="z-index:10"
          >
              <v-col cols="12">
                <v-img
                  :src="require('../assets/logo.png')"
                  class="my-3"
                  contain
                  height="250"
                />
              </v-col>

              <v-col cols="12" class="mb-4">
                <h1 class="primary--text display-2 font-weight-bold mb-3">
                  Welcome to {{ schoolName }}
                </h1>

                <p class="display-1 font-weight-light primary--text">
                  Sixth Form Application Online Portal
                </p>  
              </v-col>

              <v-col
                cols="12"
                md="4"
                offset-md="2"
                
              >
                  <v-btn
                    color="primary"
                    dark
                    large                    
                    @click="newApplication"
                  >
                    New Application
                  </v-btn>
              </v-col>  
              <v-col
                cols="12"
                md="4"
              >
                  <v-btn
                    color="primary"                    
                    outlined
                    large
                    @click="existingApplication"
                  >
                    Existing Application
                  </v-btn>
              </v-col> 
           </v-row>
        </v-container>

        <v-overlay
            :value="overlay"
            opacity="0.8"
            z-index="10"                    
        >
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>                   
        </v-overlay>

        <v-dialog
          v-model="dialog"
          width="350"
          persistentf
        >
          <v-expand-transition>
            <v-card
              v-show="existingApplicationLogin" 
              class="pb-4"
            >
              <v-card-title class="primary white--text">
                Existing Application Login
              </v-card-title>
              <v-card-text class="pa-6">
                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="applicationId"
                      label="Application ID"
                      clearable
                      autofocus
                      v-on:keyup="keyPress"
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="password"
                      :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show ? 'text' : 'password'"
                      label="Birth Certificate Pin"
                      clearable
                      @click:append="show = !show"
                      ref="password"
                      hide-details
                      v-on:keyup="keyPressPassword"
                    ></v-text-field>
                  </v-col>
                </v-row>
                
              </v-card-text>

              <v-card-actions >
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  @click="submit"
                  block
                >
                  Login
                </v-btn>
              </v-card-actions>

              <v-alert
                v-model="alert"
                color="red"
                border="left"
                colored-border
                dismissible
                type="error"
                class="red--text mx-4 mt-4"
                outlined
              >
                {{ errorMessage }}
              </v-alert>

              <v-overlay
                :value="overlayLogin"
                absolute
              >
                <v-progress-circular
                    indeterminate
                    size="64"
                ></v-progress-circular>  
              </v-overlay>
            </v-card>
          </v-expand-transition>
        </v-dialog>

        <v-dialog
          v-model="dialogApplicationCheck"
          width="350"
          persistent
        >
          <v-expand-transition>
            <v-card
              v-show="showCheckFields" 
              class="pb-4"
            >
              <v-card-title class="primary white--text">
                New Application
              </v-card-title>
              <v-card-text class="pa-6">
                <v-row v-if="error.display">
                  <v-col>
                    <v-alert type="error">
                      {{ error.message }}
                    </v-alert>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    Please enter your 
                    <span class="font-weight-bold">Birth Certificate Pin</span> and 
                    <span class="font-weight-bold">Date of Birth</span> to begin your application.
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="birthCertificatePin"
                      label="Birth Certificate Pin"
                      clearable
                      autofocus
                      hide-details
                      :rules="[value => !!value || 'Required.']"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <date-picker
                        label="Date of Birth"
                        v-bind:saveStatus="saveStatus"
                        v-on:change-date="setDateOfBirth"
                        v-bind:rules="[value => !!value || 'Required']"
                    ></date-picker>
                  </v-col>
                </v-row>
                
              </v-card-text>

              <v-card-actions class="d-flex flex-column mt-6">
                
                <v-btn
                  color="primary"
                  @click="existingApplicationCheck"
                  block
                >
                  Create Application
                </v-btn>
                <v-btn
                  color="primary"
                  outlined
                  @click="dialogApplicationCheck = false"
                  block
                  class="mt-6 ml-0"
                >
                  Cancel
                </v-btn>
              </v-card-actions>

              <v-alert
                v-model="alert"
                color="red"
                border="left"
                colored-border
                dismissible
                type="error"
                class="red--text mx-4 mt-4"
                outlined
              >
                {{ errorMessage }}
              </v-alert>

              <v-overlay
                :value="overlayApplicationCheck"
                absolute
              >
                <v-progress-circular
                    indeterminate
                    size="64"
                ></v-progress-circular>  
              </v-overlay>
            </v-card>

           
          </v-expand-transition>

        </v-dialog>

        <v-dialog
          v-model="dialogMessage"
          width="370"
        >
          <v-card flat>
            <v-alert
              border="bottom"
              colored-border
              type="warning"
              prominent
              class="text-h6 font-weight-light mb-0"
            >
              <v-row >
                <v-col class="pa-0" cols="1" offset="10">
                  <v-btn
                    icon
                    style="position:absolute; top:3px; right:3px;"
                    @click="dialogMessage = false"
                  >
                    <v-icon color="red">
                      mdi-close
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row class="">
                <v-col>
                  Sorry but the Application period has ended.
                </v-col>
              </v-row>
              
            </v-alert>
          </v-card>
        </v-dialog>
      
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import DatePicker from '../components/DatePicker.vue';
export default {

  components: {
    DatePicker,
  },

  data: function () {
    return {
      application: {
        application_id: null,
      },
      overlay: false,
      dialog: false,
      applicationId: '',
      password: '',
      show: false,
      alert: false,
      errorMessage: 'Error',
      overlayLogin: false,
      existingApplicationLogin: false,
      dialogMessage: false,
      dialogApplicationCheck: false,
      birthCertificatePin: null,
      saveStatus: {
          saving: false,
          saveSuccess: false,
          saveError: false,
      },
      showCheckFields: false,
      overlayApplicationCheck: false,
      dateOfBirth: null,
      error: {
        display: false,
        message: null
      }
    }
  },

  computed: {
    ...mapGetters({
      schoolName: 'application/getSchoolName',
    })
  },

  methods: {
    ...mapActions({
      postApplication: 'application/postApplication',
      postApplicationGrades: 'application/postApplicationGrades',
      postApplicationSubjectChoices: 'application/postApplicationSubjectChoices',
      getCSRFCookie: 'application/getCSRFCookie',
      getApplicationExisting: 'application/getApplicationExisting',
      adminSignIn: 'application/adminSignIn',
      getApplicationsLockStatus: 'application/getApplicationsLockStatus',
      getApplicationCheck: 'application/getApplicationCheck',
      getCurrentApplicationPeriod: 'application/getCurrentApplicationPeriod',
    }),

    ...mapMutations({
      setApplication: 'application/setApplication',
      setApplicationGrades: 'application/setApplicationGrades',
      setApplicationSubjectChoices: 'application/setApplicationSubjectChoices',
      setApplicationExisting: 'application/setApplicationExisting',
      setAuthenticated: 'application/setAuthenticated',
      setBirthCertificatePin: 'application/setBirthCertificatePin',
      setApplicationYear: 'application/setApplicationYear',
      storeDateOfBirth: 'application/setDateOfBirth',
      setNewApplication: 'application/setNewApplication',
    }),

    async newApplication () {
      this.dialogApplicationCheck = true;
      this.showCheckFields = true;
      // this.setBirthCertificatePin(this.birthCertificatePin);
      try {
        const { data: dataCurrentApplicationPeriod } = await this.getCurrentApplicationPeriod();
        this.setApplicationYear(dataCurrentApplicationPeriod.year)
      } catch (error) {
        if(error.response) console.log(error.response);
        else console.log(error);
      }
    },

    async existingApplicationCheck () { 
      this.error.display = false;
      this.setBirthCertificatePin(this.birthCertificatePin); 
      this.storeDateOfBirth(this.dateOfBirth);

      if(!this.birthCertificatePin || !this.dateOfBirth) {
        console.log('fields empty');
        this.error.display = true;
        this.error.message = 'Please fill out the missing fields to continue'
        return;
      }  

      try {
        this.overlayApplicationCheck = true;
        const { data } = await this.getApplicationCheck();
        this.overlayApplicationCheck = false;
        this.showCheckFields = false;
        if(!data) {
          this.dialogApplicationCheck = false;
          this.setNewApplication(true);
          this.createApplication();
        }
        else{
          this.application.application_id = data.application_id
          this.applicationId = data.application_id;
          this.password = this.birthCertificatePin;
          this.getApplication()
        }
      } catch (error) {
        this.overlayApplicationCheck = false;
        if(error.response) console.log(error.response);
        else console.log(error);
      }
    },

    setDateOfBirth (date) {
      this.dateOfBirth = date;
    },

    async createApplication () {
      this.overlay = true;
      try {
        const { data: { locked } } = await this.getApplicationsLockStatus();
        if(locked){
          this.overlay = false;
          this.dialogMessage = true;
          console.log('applications closed');
          return;
        }
        await this.getCSRFCookie();
        this.setApplication({
          date_of_birth: this.dateOfBirth,
          birth_certificate_pin: this.birthCertificatePin
        })
        const { data } = await this.postApplication();
        this.application.application_id = data.application_id;
        this.application.year = data.year;
        this.application.date_of_birth = this.dateOfBirth
        this.application.birth_certificate_pin = this.birthCertificatePin
        sessionStorage.setItem('application', JSON.stringify(this.application));
        this.overlay = false;
        this.$router.replace('/new-application');
      } catch (error) {
        if(error.response) console.log(error.response);
        else console.log(error);
        this.overlay = false;
      }
    },

    existingApplication () {
      console.log('existing application');
      this.dialog = true;
      setTimeout(() => {
        this.existingApplicationLogin = true;
      }, 700)
      
    },

    keyPress (e) {            
        if(e.keyCode === 13){
            //console.log(e);
            this.$refs.password.focus();
        }
    },

    keyPressPassword (e) {            
        if(e.keyCode === 13){
            this.submit();
        }
    },
    
    submit () {
      if(this.applicationId == 'Admin'){
        this.adminLogin();
        return
      }
      if(this.password && this.applicationId){
        this.getApplication();
      }     
      else{
        this.alert = true;
        this.errorMessage = "Please complete all fields."
      }
    },

    async getApplication () {
      this.alert = false;
      this.overlayLogin = true;
      try {
        this.setApplicationExisting({
          applicationId: this.applicationId,
          birthCertificatePin: this.password
        })
        const { data } = await this.getApplicationExisting();

        if(data){
          this.loadExistingApplication(data);
          
        }
        else{
          this.errorMessage = "Application with the credentials supplied not found."
          this.alert = true;
        }
      } catch (error) {
        if(error.response) console.log(error.response);
        else console.log(error);
        this.alert = true;
        this.errorMessage = "An Error has occured."
      }
      this.overlayLogin = false;
    },

    loadExistingApplication (data) {
      this.application.application_id = data.application_id;
      this.application.year = data.year;
      sessionStorage.setItem('application', JSON.stringify(this.application));
      this.existingApplicationLogin = false;
      setTimeout(() => {
        this.$router.replace('/new-application');
      }, 600);      
    },

    async adminLogin () {
      this.overlayLogin = true;
      console.log('login admin');
      try {
        this.setApplicationExisting({
          name: this.applicationId,
          password: this.password
        })
        await this.getCSRFCookie();
        const { data } = await this.adminSignIn();
        this.setAuthenticated(true);
        this.overlayLogin = false; 
        sessionStorage.authenticated = data;
        this.existingApplicationLogin = false;
        setTimeout(() =>{
          this.$router.replace('/admin');
        }, 700)
        
      } catch (error) {
        this.overlayLogin = false;
        this.errorMessage = "An Error has occured."
        if(error.response){
          console.log(error.response);
          let { data: { message } } = error.response
          if(message){
            this.errorMessage = message;
          }
        }
        else console.log(error);
        this.alert = true;
      }           
    }
    
  },
  
}
</script>
